import { flattenMultilineString } from '@/ai/utils/helpers'

export const buildPrompt = (sections) => {
  if (!Array.isArray(sections) || sections.length === 0) {
    return ''
  }

  let fullPrompt = ''

  sections.forEach((section, sectionIndex) => {
    let sectionString = ''

    if (section.title) {
      sectionString += `**${section.title.trim()}**\n`
    }

    const contentType = section.contentType || 'text'
    const { content } = section

    // flattenLines will remove new lines and extra spaces from the content. Will be auto-applied
    // to "text", "bullet" and "numbered" content types unless overridden in the section
    let shouldFlattenLines = section.flattenLines

    if (shouldFlattenLines === undefined) {
      shouldFlattenLines = contentType === 'text' || contentType === 'bullet' || contentType === 'numbered'
    }

    if (Array.isArray(content)) {
      let arrayContent = ''
      switch (contentType) {
        case 'bullet':
          arrayContent = content.map((item) =>
            `- ${shouldFlattenLines ? flattenMultilineString(item) : item}`).join('\n')
          break
        case 'numbered':
          arrayContent = content.map((item, i) =>
            `${i + 1}. ${shouldFlattenLines ? flattenMultilineString(item) : item}`).join('\n')
          break
        case 'text':
        default:
          arrayContent = content.map((item) => shouldFlattenLines ? flattenMultilineString(item) : item).join('\n')
          break
      }

      if (arrayContent.length > 0) {
        sectionString += arrayContent + '\n'
      }
    } else if (typeof content === 'string') {
      const language = section.language || ''

      switch (contentType) {
        case 'codeblock':
          sectionString += `\`\`\`${language}\n`
          sectionString += `${content.trim()}\n`
          sectionString += '```\n'
          break
        case 'text':
        default:
          sectionString += `${shouldFlattenLines ? flattenMultilineString(content) : content}\n`
          break
      }
    }

    fullPrompt += sectionString

    if (sectionString.trim() !== '') {
      const spacing = section.spacingAfter !== undefined ? section.spacingAfter : 2
      if (sectionIndex < sections.length - 1) {
        for (let i = 0; i < spacing; i++) {
          fullPrompt += '\n'
        }
      }
    }
  })

  let finalPrompt = fullPrompt.trim()

  if (finalPrompt) {
    finalPrompt += '\n'
  }

  return finalPrompt
}
